import styled from "styled-components/macro";
import { Text, Button } from "@gcs/design-system/react";

export const Container = styled.section(({ theme }) => ({
    padding: "40px 16px",
    gap: "32px",
    [theme.breakpoint.xl()]: {
        display: "flex",
        flexDirection: "row",
        padding: "60px 112px",
    },
}));

export const Title = styled(Text)(({ theme }) => ({
    fontSize: "32px",
    fontWeight: "700",
    lineHeight: "150%",
    marginBottom: "40px",

    [theme.breakpoint.xl()]: {
        textAlign: "left",
        fontSize: "40px",
    },
}));

export const CardContainer = styled.div(({ theme }) => ({
    padding: "32px",
    borderBottom: "1px solid #E3E0E2",

    [theme.breakpoint.lg()]: {
        alignContent: "center",
    }
}));

export const CardImage = styled.img(() => ({
    marginBottom: "32px",
}));

export const CardContent = styled.div(() => ({}));

export const CardParagraph = styled(Text)(() => ({
    marginBottom: "32px",
    fontWeight: "500",
}));

export const ActionButton = styled(Button)(({ theme }) => ({
    background: 'transparent',
    border: `1px solid ${theme.color.brandPrimary.light}`,
    borderRadius: "8px",
    fontSize: "14px",
    width: "200px",
    marginBottom: "32px",
    color: theme.color.brandPrimary.light,
    fontWeight: "700",
    padding: "16px 36px",
    boxShadow: "none",

    "&:active": {
        background: theme.color.brandPrimary.light,
        color: theme.color.neutral["08"]
    },

    [theme.breakpoint.lg()]: {
        fontSize: "18px"
    }
}));